import { render, staticRenderFns } from "./IconBedbuilderTick.vue?vue&type=template&id=491386b0&"
var script = {}
import style0 from "./IconBedbuilderTick.vue?vue&type=style&index=0&id=491386b0&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports